import React, { useEffect, useState } from 'react';
import {
  CButton,
  CCard,
  CRow,
  CCol,
  CCardHeader,
  CForm,
  CCardFooter,
  CFormLabel,
  CFormInput,
  CBadge
} from '@coreui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { insert, update, remove } from 'src/services/Returns';
import CIcon from '@coreui/icons-react';
import { cilTrash } from '@coreui/icons';
import { Toaster } from 'src/components/Toaster';
import ls from 'local-storage';
import Select, { components } from 'react-select';
import Moment from 'moment';
import { getAll, getDetails } from 'src/services/Invoices';
import formatter from 'src/reusables/formatter';
function ReturnActions() {
  let today = new Date();
  let todayMonth = today.getMonth() + 1;
  let todayYear = today.getFullYear();
  let todayDate = today.getDate();
  let showToday = todayYear + '-' + todayMonth + '-' + todayDate;
  const d = new Date();
  var month = ('0' + (d.getMonth() + 1)).slice(-2);
  var date = ('0' + d.getDate()).slice(-2);
  var datestringNow = d.getFullYear() + '-' + month + '-' + date;
  const [id, setID] = useState(0);
  const [selectedInvoice, setSelectedInvoice] = useState({});
  const [invoiceOptions, setInvoiceOptions] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [productOptions, setProductOptions] = useState([]);
  const [sku, setSKU] = useState('');
  const [name, setName] = useState('');

  const [returnDate, setReturnDate] = useState(Moment(showToday).format('YYYY-MM-DD'));
  const [diffRoll, setDiffRoll] = useState(0);
  const [diffYards, setDiffYards] = useState(0);
  const [notes, setNotes] = useState('');
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [isEdit, setIsEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [color, setColor] = useState('');

  const [unitPrice, setUnitPrice] = useState(0);
  const [returnedRolls, setReturnedRolls] = useState(0);
  const [returnedYards, setReturnedYards] = useState(0);
  const [qtyRolls, setQtyRolls] = useState(0);
  const [qtyYards, setQtyYards] = useState(0);
  const [price, setPrice] = useState(0);
  const [returnedPrice, setReturnedPrice] = useState(0);
  useEffect(() => {
    if (location.state) {
      setIsEdit(true);
      setID(location.state.id);
      setNotes(location.state.notes);
      setReturnDate(location.state.rawReturnDate);
      setSelectedInvoice({
        id: location.state.invoiceID,
        label: location.state.invoiceNo,
        value: location.state.invoiceID
      });
      setSelectedProduct({
        id: location.state.productID,
        label: location.state.productName,
        value: location.state.productID
      });
      setReturnedRolls(location.state.returnedRolls);
      setReturnedYards(location.state.returnedYards);
    }
    fetchInvoices();
  }, [location]);
  useEffect(() => {
    setReturnedPrice(location?.state?.rawReturnedAmount ?? 0);
    if (isEdit) {
    } else {
      setReturnedPrice(returnedYards * unitPrice);
    }
  }, [returnedYards]);
  const fetchDetails = async (x) => {
    let response = await getDetails(x);

    if (response.success === 1) {
      let data =
        response?.details.map((item) => {
          return {
            id: item.id,
            productID: item.product_id,
            productName: item.productName,
            qtyRoll: item.qty_roll,
            qty: item.qty_pcs,
            unitPrice: item.unit_price,
            price: item.qty_pcs * item.unit_price,
            label: `${item.productName} - ${item.unit_price}`,
            value: item.id
          };
        }) ?? [];

      setProductOptions(data);
    }
  };
  const fetchInvoices = async () => {
    let response = await getAll();

    if (response.success === 1) {
      let data =
        response?.invoices.map((item) => {
          return {
            id: item.id,
            label: `${item.invoice_number} - ${item.customer}`,
            value: item.id
          };
        }) ?? [];

      setInvoiceOptions(data);
    }
  };
  async function fDelete() {
    await remove(id).then((response) => {
      if ((response?.data?.success ?? 0) == 1) {
        setMessage(response?.data?.message);
        setOpen(true);
        const data = () =>
          setTimeout(() => {
            navigate(-1);
          }, 2000);

        data();

        return clearTimeout(data);
      } else {
        setMessage(response?.data?.message);
        setOpen(true);
        setColor('red');
      }
    });
  }
  async function handleSubmit(e) {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    if (form.checkValidity() === false) {
    } else {
      let data = {
        id: id,
        invoiceID: selectedInvoice.value,
        notes: notes,
        returnDate: returnDate,
        invoiceDetailID: selectedProduct.id,
        productID: selectedProduct.productID,
        returnedRolls: returnedRolls,
        returnedYards: returnedYards,
        returnedAmount: returnedPrice
      };
      if (location.state) {
        await update(data).then((response) => {
          if ((response?.data?.success ?? 0) == 1) {
            setMessage(response?.data?.message);
            setOpen(true);
            const data = () =>
              setTimeout(() => {
                navigate(-1);
              }, 2000);

            data();

            return clearTimeout(data);
          } else {
            setMessage(response?.data?.message);
            setOpen(true);
            setColor('red');
          }
        });
      } else {
        await insert(data).then((response) => {
          if ((response?.data?.success ?? 0) == 1) {
            setMessage(response?.data?.message);
            setOpen(true);
            const data = () =>
              setTimeout(() => {
                navigate(-1);
              }, 2000);

            data();

            return clearTimeout(data);
          } else {
            setMessage(response?.data?.message ?? ls.get('errorMessage'));
            setOpen(true);
            setColor('red');
          }
        });
      }
    }
    setValidated(true);

    // e.preventDefault()
    // console.log('bener')
  }

  return (
    <CCard>
      <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color ?? 'red'} />
      <CCardHeader>Actions - Retur</CCardHeader>
      <CForm onSubmit={(e) => handleSubmit(e)} noValidate validated={validated}>
        <div style={{ margin: '16px' }}>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Tanggal Retur</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="date"
                value={returnDate}
                max={Moment(showToday).format('YYYY-MM-DD')}
                onChange={(e) => setReturnDate(e.target.value)}
                feedbackInvalid="Required value"
                required
                disabled={isEdit}
              />
            </CCol>
          </CRow>{' '}
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Invoice</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <Select
                placeholder="Pilih Invoice"
                value={selectedInvoice}
                options={invoiceOptions}
                onChange={(e) => {
                  setSelectedInvoice(e);
                  setProductOptions([]);
                  setSelectedProduct({});
                  setReturnedRolls(0);
                  setReturnedYards(0);
                  setPrice(0);
                  setReturnedPrice(0);
                  setUnitPrice(0);
                  fetchDetails(e.id);
                }}
                isDisabled={isEdit}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>{' '}
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Barang</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <Select
                placeholder="Pilih Barang"
                value={selectedProduct}
                options={productOptions}
                onChange={(e) => {
                  setSelectedProduct(e);

                  setQtyRolls(e.qtyRoll);
                  setQtyYards(e.qty);
                  setReturnedRolls(0);
                  setReturnedYards(0);
                  setPrice(e.price);
                  setReturnedPrice(0);
                  setUnitPrice(e.unitPrice);
                }}
                isDisabled={isEdit}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>
          {selectedProduct == {} ? (
            <div></div>
          ) : (
            <div>
              <CCol>
                <CRow className="mb-3">
                  <CCol md={3}>Satuan</CCol>
                  <CCol md={3}>Qty Order</CCol>
                  <CCol md={3}>Qty Retur</CCol>
                </CRow>{' '}
                <CRow className="mb-3">
                  <CCol md={3}>Roll</CCol>
                  <CCol md={3}>{qtyRolls}</CCol>
                  <CCol md={3}>
                    {' '}
                    <CFormInput
                      type="text"
                      value={returnedRolls}
                      onChange={(e) => setReturnedRolls(e.target.value)}
                      feedbackInvalid="Required value"
                      required
                      disabled={isEdit}
                    />
                  </CCol>
                </CRow>
                <CRow className="mb-3">
                  <CCol md={3}>Yard</CCol>
                  <CCol md={3}>{qtyYards}</CCol>
                  <CCol md={3}>
                    {' '}
                    <CFormInput
                      type="text"
                      value={returnedYards}
                      onChange={(e) => setReturnedYards(e.target.value)}
                      feedbackInvalid="Required value"
                      required
                      disabled={isEdit}
                    />
                  </CCol>
                </CRow>
                <CRow className="mb-3">
                  <CCol md={3}>Nilai(Rp)</CCol>
                  <CCol md={3}>{formatter('currency', price)}</CCol>
                  <CCol md={3}>{formatter('currency', returnedPrice)}</CCol>
                </CRow>
              </CCol>
            </div>
          )}
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Notes</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="text"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                feedbackInvalid="Required value"
                required
                disabled={isEdit}
              />
            </CCol>
          </CRow>
        </div>
        {/* const [diffRoll, setDiffRoll] = useState(0); const [diffYards, setDiffYards] = useState(0); */}
        <CCardFooter style={{ textAlign: 'right' }}>
          {location.state ? (
            <CButton
              color="danger"
              onClick={() => {
                fDelete();
              }}
            >
              <CIcon icon={cilTrash} />
            </CButton>
          ) : (
            <div></div>
          )}
          &emsp;
          <CButton
            style={{
              color: 'black',
              backgroundColor: 'white'
            }}
            onClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </CButton>
          &emsp;
          <CButton
            color="success"
            style={{
              color: 'white'
            }}
            type="submit"
          >
            Save
          </CButton>
        </CCardFooter>
      </CForm>
    </CCard>
  );
}

export default ReturnActions;
